import { FC } from 'react';
import AppControl from './AppControl';
import AppCustom from './AppCustom';
import { useGlobal } from '@/utils/useGlobal';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const FeatApp: FC = () => {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const sites = ['fr', 'de', 'it', 'es', 'jp', 'sa'];

    if (sites.includes(locale)) {
        return <AppCustom />;
    } else if (SHOW_APP_POINT_SITES.includes(locale)) {
        return <AppPointDeltaAdv />;
    } else {
        return <AppControl />;
    }
};

export default FeatApp;
